import { motion } from "framer-motion";

export const EASE = [0.76, 0, 0.24, 1];
export const SOFT = [0.22, 1, 0.36, 1];

export const introDelay = () => Math.max(0.15, ((window.__mpIntroEnd || 0) - Date.now()) / 1000 - 0.25);

export const MaskLines = ({ lines, delay = 0 }) =>
  lines.map((l, i) => (
    <span key={i} className="block overflow-hidden pb-[0.06em] -mb-[0.06em]">
      <motion.span
        className={`block ${l.className || ""}`}
        initial={{ y: "115%", rotate: 4 }}
        animate={{ y: 0, rotate: 0 }}
        transition={{ duration: 1.05, delay: delay + i * 0.11, ease: EASE }}
      >
        {l.text}
      </motion.span>
    </span>
  ));

export const Reveal = ({ children, delay = 0, y = 40, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, delay, ease: SOFT }}
  >
    {children}
  </motion.div>
);
